import React from 'react';
import { useDevMode } from '@/hooks/useDevMode';
import { getRoleDisplayName, UserRole } from '@/lib/rolePermissions';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { Bug } from 'lucide-react';

export const DevModeToggle: React.FC = () => {
  const { actualRole, simulatedRole, setSimulatedRole, canUseDevMode, isSimulating } = useDevMode();

  if (!canUseDevMode) {
    return null;
  }

  const handleValueChange = (value: string) => {
    if (value === 'off') {
      setSimulatedRole(null);
    } else {
      setSimulatedRole(value as UserRole);
    }
  };

  return (
    <div className="p-3 border-t border-amber-200 bg-amber-50/50">
      <div className="flex items-center gap-2 mb-2">
        <Bug className="h-4 w-4 text-amber-600" />
        <span className="text-xs font-medium text-amber-800">Dev Mode</span>
      </div>
      
      <Select value={simulatedRole || 'off'} onValueChange={handleValueChange}>
        <SelectTrigger className="h-8 text-xs bg-white border-amber-200">
          <SelectValue placeholder="Välj roll" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="off" className="text-xs">
            <span className="font-medium">System Admin</span>
            <span className="text-muted-foreground ml-1">(din roll)</span>
          </SelectItem>
          <SelectItem value="admin" className="text-xs">
            → Kund-admin
          </SelectItem>
          <SelectItem value="moderator" className="text-xs">
            → Senior revisor
          </SelectItem>
          <SelectItem value="user" className="text-xs">
            → Junior revisor
          </SelectItem>
        </SelectContent>
      </Select>

      {isSimulating && simulatedRole && (
        <Badge variant="outline" className="mt-2 text-amber-700 border-amber-300 bg-amber-100 text-xs">
          Simulerar: {getRoleDisplayName(simulatedRole)}
        </Badge>
      )}
    </div>
  );
};
